/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Schedule, Schedule$inboundSchema } from "./schedule.js";
import { Sequence, Sequence$inboundSchema } from "./sequence.js";

/**
 * Measurable or changeable aspect of a device.
 */
export type SettingValue = {
  /**
   * Boolean setting value
   */
  boolean?: boolean | undefined;
  /**
   * Enum setting value
   */
  enum?: string | undefined;
  /**
   * Number setting value
   */
  number?: number | undefined;
  /**
   * The schedule value of
   */
  schedule?: Schedule | undefined;
  /**
   * The sequence value
   */
  sequence?: Sequence | undefined;
  /**
   * String setting value
   */
  string?: string | undefined;
};

/** @internal */
export const SettingValue$inboundSchema: z.ZodType<
  SettingValue,
  z.ZodTypeDef,
  unknown
> = z.object({
  boolean: types.optional(types.boolean()),
  enum: types.optional(types.string()),
  number: types.optional(types.number()),
  schedule: types.optional(Schedule$inboundSchema),
  sequence: types.optional(Sequence$inboundSchema),
  string: types.optional(types.string()),
});

export function settingValueFromJSON(
  jsonString: string,
): SafeParseResult<SettingValue, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SettingValue$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SettingValue' from JSON`,
  );
}
